export default {
    getOs() {
        if (window.PPDWebUI && window.PPDWebUI.os.inApp && window.PPDWebUI.os.android) {
            return 2;
        } else {
            return 1;
        }
    },

    // 设置h5网关跟多租户网关的请求头
    setHeader(type) {
        let header = {};
        if (type === 'multi') {
            header = {
                'X-GW-TENANTID': 'f36caab1',
                'X-GW-APPID': '1000002863',
                'X-GW-PLATFORM': 'h5',
                'X-GW-TIMESTAMP': parseInt(new Date().getTime() / 1000).toString(),
                'X-GW-TOKEN': this.getCookie('token')
            };
        } else {
            header = {
                'X-PPD-APPOS': this.getOs().toString(),
                'X-PPD-APPID': this.getUseragentKey().appId.toString(),
                'X-PPD-APPVERSION': this.getUseragentKey().version.toString(),
                'X-PPD-TIMESTAMP': parseInt(new Date().getTime() / 1000).toString(),
                'X-PPD-KEY': 'tc-002',
                'X-PPD-KEYVERSION': '1'
            };
        }
        return header;
    },

    getCookie(name) {
        let arr;
        let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if ((arr = document.cookie.match(reg))) return arr[2];
        else return null;
    },

    uuid() {
        let s = [];
        let hexDigits = '0123456789abcdef';
        for (let i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = '-';

        let uuid = s.join('');
        return uuid;
    },

    setTimestamp(t) {
        if (t) {
            let year = t.getFullYear();
            let month = this.addZeroToNumber(t.getMonth() + 1, 2);
            let date = this.addZeroToNumber(t.getDate(), 2);
            let hour = this.addZeroToNumber(t.getHours(), 2);
            let min = this.addZeroToNumber(t.getMinutes(), 2);
            let seconds = this.addZeroToNumber(t.getSeconds(), 2);
            let milliSeconds = this.addZeroToNumber(t.getMilliseconds(), 3);
            return (
                [year, month, date].join('-') +
                ' ' +
                [hour, min, seconds].join(':') +
                '.' +
                milliSeconds
            );
        } else {
            return false;
        }
    },
    // 对数字进行补位
    addZeroToNumber(num, count) {
        let arr = [];
        let len = String(num).length;
        if (len < count) {
            let space = count - len;
            for (let i = 0; i < space; i++) {
                arr.push('0');
            }
            return arr.join('') + num;
        }
        return num;
    },
    getMiappUseragentKey() {
        let appId =  '';
        if (window.__wxjs_environment === 'miniprogram' && this.getCookie('miniappPlatform')) { 
            if (!(window.location.protocol.indexOf('http:') > -1)) { 
                appId = '41001'
            }
        }
        let isTTWebView = navigator.userAgent.toLowerCase().includes("toutiaomicroapp");
        if (isTTWebView) {
            if (!(window.location.protocol.indexOf('http:') > -1)) { 
                appId = '41002'
            }
        }
        return {
            appId: appId
        };
     },
    // 从useragent里面获取相应的参数
    getUseragentKey() {
        let userAgent = navigator.userAgent;
        // pid是PPDLoanApp
        // version是7.4.0.19012402
        // appid是10080004
        // duid是cee8a5af63ba7bbfcfaa0ebff9b68b7042282767
        // openid暂时不传
        let list = [
            'PPDLoanApp',
            'PPDHuanApp',
            'PPDCSDApp',
            'PPDJQHApp',
            'PPDBBCarApp',
            'PPDKoouApp',
            'PPDKoobApp',
            'PPDLenderApp'
        ];
        let len = list.length;
        // 找到对应的渠道pid
        for (let i = 0; i < len; i++) {
            if (userAgent.indexOf(list[i]) > -1) {
                var pid = list[i];
            }
        }
        let appIdReg = /.*AppID\/(\d+).*/;
        let duidReg = /.*DUID\/([a-zA-Z0-9]+).*/;
        let versionReg = new RegExp('.*' + pid + '/([.0-9]+).*');
        let buildTypeReg = /.*BuildType\/([a-zA-Z]+)*/;
        let appId = (appIdReg.exec(userAgent) && appIdReg.exec(userAgent)[1]) || '';
        // let duid = duidReg.exec(userAgent) && duidReg.exec(userAgent)[1] || '';
        let duid =
            (window.PPDWebUI && window.PPDWebUI.appInfos && window.PPDWebUI.appInfos.DUID) ||
            (duidReg.exec(userAgent) && duidReg.exec(userAgent)[1]) ||
            '';
        let version = (versionReg.exec(userAgent) && versionReg.exec(userAgent)[1]) || '';
        let buildType = (buildTypeReg.exec(userAgent) && buildTypeReg.exec(userAgent)[1]) || '';
        let platform = '';
        if (userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1) {
            //android终端
            platform = 'android';
        } else {
            platform = 'ios';
        }

        return {
            pid: pid,
            appId: appId,
            duid: duid,
            version: version,
            platform,
            buildType: buildType === 'Debug' ? '1' : '2'
        };
    },

    removeLoading() {
        let loadings = document.querySelectorAll('.ppd-loading-wrap');
        loadings = Array.from(loadings);
        loadings.forEach(item => {
            document.body.removeChild(item);
        });
    },

    addLoading(hasMask) {
        let maskHtml = '<div class="ppd-loading-mask"></div>';
        let str =
            '<span class="loading"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="white">' +
            '<path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"/>' +
            '<path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">' +
            '<animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite" />' +
            '</path>' +
            '</svg><span>';
        hasMask && (str = maskHtml + str);
        let el = document.createElement('div');
        // 插入style
        let style = document.createElement('style');
        let cssText = `.ppd-loading-wrap{position:relative;z-index:9999;}
            .ppd-loading-wrap .loading{
                position: fixed;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -ms-flex-pack: center;
                justify-content:center;
                width:100px;
                height:100px;
                background:rgba(0,0,0,0.3);
                border-radius:8px;}
            .ppd-loading-mask{
                position:fixed;
                top:0;
                left:0;
                right:0;
                bottom:0;
                background:rgba(0,0,0,0);}`;
        style.innerHTML = cssText;
        style.type = 'text/css';
        document.head.appendChild(style);
        el.innerHTML = str;
        // el.classList = 'ppd-loading-wrap';
        el.className = 'ppd-loading-wrap';
        document.body.appendChild(el);
    },
    toastError(message) {
        let judgeToast = document.querySelector('.ppd-toast-wrap');
        if (judgeToast) {
            return;
        }
        let style = document.createElement('style');
        let cssText =
            '.ppd-toast-wrap{animation:showToast 0.5s;animation-fill-mode: forwards;position:fixed;z-index:9998;top:50%;left:50%;transform:translate(-50%,-50%);max-width:80%;line-height:22px;padding:10px;text-align:center;border-radius:3px;background:rgba(0,0,0,0.9);color:#fff;font-size:14px;}@keyframes showToast{0% {opacity:0;} 100% {opacity:0.9;}}';
        style.innerHTML = cssText;
        document.head.appendChild(style);
        let el = document.createElement('div');
        el.className = 'ppd-loading-wrap';
        el.innerText = message;
        document.body.appendChild(el);
        setTimeout(() => {
            el.parentNode.removeChild(el);
        }, 2000);
    },
};
